import { useEffect, useState } from "react"
import { savedReceiversAPI } from "../../../api/savedReceivers/savedReceiver"
import { useDispatch } from "react-redux";
import { pushAlert } from "../../alerts/alertSlice";
import style from "../../../sass/custom/buttons.module.scss";
import { useTranslation } from "react-i18next";
import GreenSpinner from "../../../components/loaders/GreenSpinner";
import { upload } from "../../citySelect/selectCitySlice";

const ReceiversList = ({goBack, setName, setReceiverCompany, setAddress, setPostalIndex, setPhoneNumber, setEmail, setChoosedFromSaved, setReceiverGeolocation}) => {
    const [receivers, setReceivers] = useState([])
    const [uploadingStatus, setUploadingStatus] = useState("idle") // "idle" | "pending" | "success" | "error"
    const {t} = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {
        setUploadingStatus("pending")
        
        savedReceiversAPI.getSavedReceivers().then((res) => {
            if (!res.ok) {
                dispatch(pushAlert({
                    message: t("shipments.create_shipment.saved_receivers.errors.unable_to_load"),
                    type: "error",
                    delay: 2000,
                }))
                goBack();
                return;
            }
            setReceivers(res.data)
            setUploadingStatus("success")
        })
    }, [dispatch, goBack, t])

    const handleReceiverClick = (receiver) => {
        setName(receiver.name)
        setReceiverCompany(receiver.company)
        setAddress(receiver.address)
        setPostalIndex(receiver["postal-index"].toString())
        setPhoneNumber(receiver["phone-number"].toString())
        setEmail(receiver.email)
        setReceiverGeolocation(receiver.geolocation)
        setChoosedFromSaved(true)
        
        goBack();
    }

    return (
    <div className="flex flex-col gap-2">
        <button className={`${style.btn} ${style["btn-red"]}`} onClick={() => goBack()}>
            {t("shipments.create_shipment.saved_receivers.fill_manually")}
        </button>
        {
            uploadingStatus === "pending" && <div className="text-center"><GreenSpinner /></div>
        }
        {
            uploadingStatus === "success" && receivers.length === 0 && 
            <div className="text-left">
                {t("saved_receivers.no_saved_receivers")}
            </div>
        }
        {receivers?.map((receiver) => {
            return (
                <div 
                    className="border py-2 px-2 text-left cursor-pointer" 
                    key={receiver.id}
                    onClick={() => {handleReceiverClick(receiver)}}
                >
                    <span className="font-bold">{receiver.name} {" "}</span>
                    {receiver["phone-number"]}
                </div>
            )
        })}
    </div>
  )
}

export default ReceiversList